import About from "./components/About";
// import Contact from "./components/Contact";
import Experience from "./components/Experience";
import Home from "./components/Home";
import Navbar from "./components/Navbar";
import Portfolio from "./components/Portfolio";
import Slideshow from "./components/Slideshow";
import SocialLinks from "./components/SocialLinks";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Home />
      <SocialLinks />
      <About />
      <Slideshow />
      {/* <Portfolio /> */}
      
      <Experience />
      {/* <Contact /> */}
    </div>
  );
}

export default App;
